module.exports = __webpack_public_path__ + "static/bb-567dcd6e20b2749e826d043bbcec8e24.png";